import { Path } from '@/main/router/routerPath';

import { ServiceDueDetails } from '../administrace/serviceDueDetails';
import { Managment } from './managment/index';
import { Servis } from './servis';
import { SkladND } from './skladNd';
import { AppointmentList } from './AppointmentList';
import { ServiceOrderHistory } from '../administrace/serviceOrderHistory';
import { LabourSales } from './LabourSales';
import { PendingJobsAndSafetyList } from './PendingJobsAndSafetyList';
import { AbcFmsAnalysis } from '../sklad/abcFmsAnalysis';
import { AccountReceivable } from './AccountReceivable';
import { PartSales } from './PartSales';
import { DailyPerformance } from './DailyPerformance';
import { InventoryAdjustment } from './InventoryAdjustment';
import { NonReceivedPartsPO } from './NonReceivedPartsPO';
import { OutSourcingDetail } from './OutSourcingDetail';
import { TimeClocking } from './TimeClocking';
import { TechnicianClocking } from './TechnicianClocking';
import { OutstandingRevenue } from './OutstandingRevenue';
import { RevenueDetails } from './RevenueDetails';

import { StockValueMovement } from './StockValueMovement';
import { CashierReport } from './CashierReport';
import { ItemsReceivedDetail } from './ItemsReceivedDetail';
import { WorkInProgress } from './WorkInProgress';
import { RealTimeInventory } from './RealTimeInventory';
import { DetailsOfItemsTransfer } from './DetailsOfItemsTransfer';
import { ReportRequest } from './ReportRequest';
import { AdvancePayment } from './AdvancePayment';
import { StockAgingAnalysis } from './StockAgingAnalysis';

export const router = new Path('servis').addChildren([
	Servis.router,
	SkladND.router,
	Managment.router,
	ServiceOrderHistory.router,
	ServiceDueDetails.router,
	AppointmentList.router,
	LabourSales.router,
	PendingJobsAndSafetyList.router,
	AbcFmsAnalysis.router,
	AccountReceivable.router,
	PartSales.router,
	DailyPerformance.router,
	InventoryAdjustment.router,
	NonReceivedPartsPO.router,
	OutSourcingDetail.router,
	TimeClocking.router,
	TechnicianClocking.router,
	OutstandingRevenue.router,
	RevenueDetails.router,
    WorkInProgress.router,
	TimeClocking.router,
	StockValueMovement.router,
	CashierReport.router,
	ItemsReceivedDetail.router,
	RealTimeInventory.router,
	DetailsOfItemsTransfer.router,
	ReportRequest.router,
	AdvancePayment.router,
	StockAgingAnalysis.router,
]);
